export default __webpack_public_path__ + "static/media/Michael-Finkelstein.65c0a9f8.png";